<template>
  <el-dialog class="full-screen-popup" :visible.sync="visible" :append-to-body="true" fullscreen :modal="false" :show-close="false" @close="close">
    <el-row class="title-bg" slot="title" type="flex" justify="space-between">
      <el-col :span="23.5">
        <h2 class="title">크게보기 | {{ templateName }}</h2>
      </el-col>
      <el-col :span="0.5">
        <el-tooltip content="축소" placement="bottom">
          <el-button size="medium" @click="close"  class="fl-r"><i class="fas fa-compress-alt" /></el-button>
        </el-tooltip>
      </el-col>
    </el-row>
    <el-scrollbar class="bar-visible">
      <div class="popup-content">
        <div v-for="chart in expandedChartList" :key="chart.orderbyIndex">
          <w-common-line-chart v-show="chart.visible" ref="commonLineChart" :rscInfoList="chart.items" :orderbyIndex="chart.orderbyIndex" :deleteFlag="false"
          @mouseOver="onMouseOverChart" @mouseOut="onMouseOutChart" @clickChart="onClickChart" />
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>
</template>

<script>
import filter from 'lodash/filter';
import { isEmpty } from '@/utils/basic';
import ChartAnalaysisMixin from '@/mixins/chart/chart-analysis';
import WCommonLineChart from '../chart/CommonLineChart';

export default {
  name: 'WExpandedChartView',
  components: { WCommonLineChart },
  mixins: [ChartAnalaysisMixin],
  props: {
    templateName: String,
    chartList: Array,
  },
  data() {
    return {
      visible: false,
      expandedChartList: [],
    };
  },
  methods: {
    open() {
      // 삭제된 시리즈는 제외한다.
      const chartList = this.chartList;
      chartList.forEach((chart) => {
        const items = chart.items;
        chart.items = filter(items, (record) => isEmpty(record.deleted) || !record.deleted);
      });
      this.expandedChartList = chartList;

      this.visible = true;
      this.$store.dispatch('openFullScreenLayer');
    },
    close() {
      this.visible = false;
      this.$store.dispatch('closeFullScreenLayer');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/chart/components/view/ExpandedChartView.vue